<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text Generate PDF
    v-row
      v-col(cols="6")
          v-select(
              v-model="instance.orientation",
              :label="$t('ActionTemplate.orientation')",
              :items=["Horizontal","Vertical"],
              :loading="loading",
              return-object,
              item-text="name",
              item-value="id",
          )
    code-editor(
      v-model="instance.body",
      language="htmlembedded"
    )
    v-row
      v-col(cols="12")
        document-request-selector(
          v-model="instance.attachments",
          :currentValues="{applicableOn: instance.entityName, id: instance.documentRequestId, name: instance.documentRequestLabel, entityFileId: instance.entityId}",
          :multiple="false",
          :setEntityFileId="true"
        )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>
import DocumentRequestSelector from '@/components/ActionTemplate/DocumentRequestSelector';

export default {
  props: ['value', 'attachReport'],
  components: { DocumentRequestSelector },
  data: function ()  {
    return {
      initialObject: {
        type: 'Generate Pdf',
        body: '',
        isRazor: true,
        documentRequestId: null,
        entityName: '',
        entityId: '',
        entityFileExternalId: '@Model.ExternalId',
        documentRequestLabel: ''
      },
      instance: {},
      attachment: {},
    }
  },
  computed: {

  },
  watch: {
    instance: {
      immediate: false,
      deep: true,
      handler(val) {
        //update values before emit
        if(val && this.instance.attachments)
        {
          val.documentRequestId = this.instance.attachments.id;
          val.entityName = this.instance.attachments.applicableOn;
          val.documentRequestLabel = this.instance.attachments.name;
          val.entityId = this.instance.attachments.entityFileId;
          delete this.instance.attachments;
        }
        this.$emit('input', val);
      },
    },
  },
  methods: {

  },
  created() {
    this.instance = { ...this.initialObject, ...this.value };
    if(this.instance.orientation == null) this.instance.orientation = "Vertical";
  },
}
</script>
